<template>
    <div id="content">
        <loader></loader>
        <div class="top" style="position:relative;">
            <div class="header">
                <h1>Statistiques</h1>
            </div>
    
            <div class="options" style="justify-content: flex-start;">
                <div class="searchBar pickDate ">
                    <DatePicker mode='range' v-model='dateRange'></DatePicker>
                </div>
                <div class="searchBar drop">
                    <multi-list-select
                        :list="users"
                        :selectedItems="usersSelect"
                        option-value="id"
                        :custom-text="user"
                        placeholder="Sélectionner une secrétaire"
                        :isDisabled="!$store.getters.hasPerm('call:add/edit:user')"
                        @select="onSelectUser">
                    </multi-list-select>
                </div>
                <div class="searchBar drop">
                    <multi-list-select
                        :list="customers"
                        :selectedItems="customersSelect"
                        option-value="id"
                        option-text="company"
                        placeholder="Sélectionner un client"
                        @select="onSelectCustomer">
                    </multi-list-select>
                </div>
                <div class="searchBar drop">
                    <multi-list-select
                        :list="reasons"
                        :selectedItems="reasonsSelect"
                        option-value="id"
                        option-text="label"
                        placeholder="Sélectionner un motif"
                        @select="onSelectReason">
                    </multi-list-select>
                </div>
            </div>
            <form class="" action="" method="post" autocomplete="off">
                <div class="line" style="margin-left:20px">
                    <btn text="Exporter les appels" @click="exportCalls"/>
                    <btn text="Exporter les stats" @click="exportStats"/>
                </div>
            </form>
        </div>
        <div class="top" style="position:relative;z-index: 10">
            <div class="header">
                <h1>Primes</h1>
            </div>
            <div>
                <table>
                    <tr>
                        <td>Base Radio Conv</td>
                        <td>Base Imagerie Coupe</td>
                        <td>Montant prime base</td>
                    </tr>
                    <tr v-for="base in bases">
                        <td>{{timestampToString(base.base_radio_conv)}}</td>
                        <td>{{timestampToString(base.base_imagerie_coupe)}}</td>
                        <td>{{base.prime}}€</td>
                    </tr>
                </table>
            </div>
        </div>
        
    </div>
</template>

<script>
import Loader from "@/components/Loader";
import moment from "moment";
import Btn from "@/components/Btn";
import tools from '../config.ts';
import axios from "axios";
import MultiListSelect from "vue-search-select/src/lib/MultiListSelect";
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

export default {
    name: "Stats",
    components: {Loader, Btn, MultiListSelect, DatePicker},
    data(){
        return {
    
            customers: [],
            customersSelect: [],
            reasons: [],
            reasonsSelect: [],
            users: [],
            usersSelect: [],
            date_start:moment().subtract(1,'months').startOf("months"),
            date_end:moment().subtract(1,'months').endOf('month'),
    
            bases:[]
        }
    },
    methods:{
        user(user) {
            if (user.firstname && user.lastname) {
                return user.firstname+" "+user.lastname;
            }
        
            return user.login;
        },
        async exportCalls(){
            tools.loader(true)
            
            try {
                let config = tools.headerPOST();
                let response = await axios.post(tools.api("export/calls"), tools.toPOST({
                    customers: this.customersSelect.map((customer) => customer.id).join(","),
                    reasons: this.reasonsSelect.map((reason) => reason.id).join(","),
                    users: this.usersSelect.map((reason) => reason.id).join(","),
                    date_start: this.date_start,
                    date_end: this.date_end,
                }),config)
    
                let csvContent = "data:text/csv;charset=utf-8,";
                csvContent += response.data.csv
                const data = encodeURI(csvContent);
                const link = document.createElement("a");
                link.setAttribute("href", data);
                link.setAttribute("download", "export_calls_"+moment().format("YYYYMMDD_HHmmss")+".csv");
                link.click();
            }catch(e){
            
            }
            
            tools.loader(false)
        },
        async exportStats(){
    
            tools.loader(true)
    
            try {
                let config = tools.headerPOST();
                let response = await axios.post(tools.api("export/stats"), tools.toPOST({
                    customers: this.customersSelect.map((customer) => customer.id).join(","),
                    reasons: this.reasonsSelect.map((reason) => reason.id).join(","),
                    users: this.usersSelect.map((reason) => reason.id).join(","),
                    date_start: this.date_start,
                    date_end: this.date_end,
                }),config)
                console.log(response.data)
                let csvContent = "data:text/csv;charset=utf-8,";
                csvContent += response.data.csv
                const data = encodeURI(csvContent);
                const link = document.createElement("a");
                link.setAttribute("href", data);
                link.setAttribute("download", "stats_calls_"+moment().format("YYYYMMDD_HHmmss")+".csv");
                link.click();
            }catch(e){
        
            }
    
            tools.loader(false)
        },
        onSelectCustomer(items) {
            this.customersSelect = items;
        },
        onSelectReason(items) {
            this.reasonsSelect = items;
        },
        onSelectUser(items) {
            this.usersSelect = items;
        },
        stringToTimestamp(string){
            let data = string.split(":");
            let h = parseInt(data[0]) * 3600
            let m = parseInt(data[1]) * 60
            let s = parseInt(data[2])
        
            return h+m+s;
        },
        timestampToString(time){
            let start = moment(0);
            let date = moment(time*1000);
            let diff = moment.duration(date.diff(start))
        
            let h = parseInt(diff.asHours());
            h = h < 10 ? "0"+h : h;
            let m = parseInt(diff.minutes());
            m = m < 10 ? "0"+m : m;
            let s = parseInt(diff.seconds());
            s = s < 10 ? "0"+s : s;
        
            return h+":"+m+":"+s
        
        }
    },
    computed:{
        dateRange: {
            set(newDate) {
                this.date_start = moment(newDate.start).format("YYYY-MM-DD");
                this.date_end = moment(newDate.end).format("YYYY-MM-DD");
            },
            get() {
                return {
                    start: moment(this.date_start).toDate(),
                    end: moment(this.date_end).toDate(),
                }
            }
        },
    },
    async mounted() {
        // customers load for search bar
        let customer = await axios.get(tools.api("customers"), tools.headerGET())
        this.customers = customer.data;
    
        // reasons load for search bar
        let reasons = await axios.get(tools.api("reasons"), tools.headerGET())
        this.reasons = reasons.data;
    
        // users load for search bar
        let users = await axios.get(tools.api("users"), tools.headerGET())
        this.users = users.data;
        
        let bases = await axios.get(tools.api("option/base"),tools.headerGET())
        this.bases = JSON.parse(bases.data.value);
        console.log(this.bases)
    }
}
</script>